import React, { useState } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import "./login.css";

// import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();


  //PASSWORD VIEW
const [showPassword, setShowPassword] = useState(false);


  const login = async () => {
    try {
      // Sign in the user
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // Fetch the user's role from Firestore
      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        const { role } = userDoc.data();

        // Navigate to the appropriate dashboard based on role
        if (role === "admin") {
          navigate("/AdminPanel");

        } else if (role === "consultant") {
          navigate("/Consultant");

        } else if (role === "student") {
          navigate("/StudentDashboard");
        

        }   else if (role === "sub-admin") {
          navigate("/create-student-dashboard");
        
        }else if (role === "oldstudent") {
          navigate("/cpd-panel");

        }  else if (role === "admin-d") {
          navigate("/AdminPanel-D");

        }else if (role === "admin-t") {
          navigate("/AdminPanel-T");

        }else if (role === "supervisionadmin") {
          navigate("/supervision-admin-panel");
        } 


        else {
          alert("Role not recognized. Contact admin.");
        }
      } else {
        alert("No user data found. Please contact admin.");
      }
    } catch (error) {
      console.error("Error logging in:", error.message);
      alert(error.message);
    }
  };



  const navigateToForgotPassword = () => {
   
    navigate('/ForgotPassword');
  };

  return (

<div className="login-container">
      <div className="login-panel">
        <div className="left-panel">
          <h1 className="heading-login">Login Panel</h1>
          <input
            type="email"
            placeholder="Please Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type={showPassword ? "text" : "password"}  // Toggle input type based on showPassword state
            placeholder="Please Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          



          {/* Forgot Password Link */}
          <div>
            <a 
              href="/ForgotPassword" 
              className="forgot-password-link"
              onClick={(e) => {
                e.preventDefault(); // Prevent default action if using JavaScript handling
                navigateToForgotPassword(); // Optional: Function to navigate programmatically
              }}
            >
              Forgot Password?
            </a>
          </div>

          <button onClick={login}>Login</button>
        </div>
<div className="right-panel">
  <img src="invoice logo.png" alt="Southern Rehab Care Logo" className="logo" />
  <h2>Recovery Tracking APP</h2>
  <p>
    A secure and intelligent patient recovery management platform designed for
    scoliosis and spinal rehabilitation programs. The application
    ensures efficient collaboration, accurate documentation, and
    improved patient care throughout the rehabilitation journey.
  </p>
</div>
      </div>
    </div>

  );
};

export default Login;
